import { Breadcrumb } from '../../types';

export const programBreadcrumbs: Map<string, Breadcrumb> = new Map([
	[
		'draftPrograms',
		{
			name: 'Draft Programs',
			to: '/programs/draft',
			i18nKey: 'breadcrumb.draftPrograms',
		},
	],
	[
		'publishedPrograms',
		{
			name: 'Published Programs',
			to: '/programs/published',
			i18nKey: 'breadcrumb.publishedPrograms',
		},
	],
	[
		'programEventAddJobs',
		{
			name: 'Add Program Jobs',
			i18nKey: 'breadcrumb.addProgramJobs',
		},
	],
	[
		'programEventAddJobs',
		{
			name: 'Add Volunteering',
			i18nKey: 'breadcrumb.addProgramJobs',
		},
	],
	[
		'programEventAddEvents',
		{
			name: 'Add Activities',
			i18nKey: 'breadcrumb.addProgramEvents',
		},
	],
	[
		'funderReport',
		{
			name: 'Funder report',
			i18nKey: 'breadcrumb.funderReport',
		},
	],
	[
		'programReports',
		{
			name: 'programReports',
			i18nKey: 'breadcrumb.programReports',
		},
	],
	[
		'programEventDetails',
		{
			name: 'programEventDetails',
			i18nKey: 'breadcrumb.programEventDetails',
		},
	],
	[
		'proposalAndEvaluation',
		{
			name: 'proposalAndEvaluation',
			i18nKey: 'breadcrumb.proposalAndEvaluation',
		},
	],
	[
		'evaluationDetails',
		{
			name: 'evaluationDetails',
			i18nKey: 'breadcrumb.evaluationDetails',
		},
	],
	[
		'advancePaymentRequest',
		{
			name: 'advancePaymentRequest',
			i18nKey: 'breadcrumb.advancePaymentRequest',
		},
	],
	[
		'createAdvancePaymentRequest',
		{
			name: 'Create advance payment request',
			i18nKey: 'breadcrumb.createAdvancePaymentRequest',
		},
	],
	[
		'advancePaymentRequestName',
		{
			//placeholder, to be filled by Breadcrumbs.vue
			name: 'advancePaymentRequestName',
		},
	],
	[
		'relatedEvents',
		{
			name: 'Related Events',
			i18nKey: 'breadcrumb.relatedEvents',
		},
	],
]);
